import request from "@/http"
import type { StoreProfile } from "@/api"
// ==============================================
export interface SimilarStoreVO {
  name: string
  poiId: string
  grid: string
  similarity: number
  lon: number
  lat: number
}

/**
 * 获取相似门店
 */
export async function getSimilarStores(name: string): Promise<SimilarStoreVO[]> {
  try {
    const result = await request.get<SimilarStoreVO[]>(`/v2/starbucks/similar`, {
      params: {
        name,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

interface LocationsItemVO {
  lat: number
  lon: number
  poiId: string
}

interface SimilarAnalysisArgs {
  brandId: string
  cityId: string
  locations: LocationsItemVO[]
}

type SimilarAnalysisVO = StoreProfile & {
  poiId: string
}

/**
 * 获取当前门店的相似门店分析数据
 */
export async function getSimilarStoreAnalysis(
  params: SimilarAnalysisArgs,
): Promise<SimilarAnalysisVO[]> {
  try {
    const result = await request.post<SimilarAnalysisVO[]>(`/v2/starbucks/comparison`, params)
    return result?.data
  } catch (error) {
    throw error
  }
}

export interface BusinessDistrictVO {
  placeId: string
  lon: number
  lat: number
  placeName: string
  provinceName: string
  cityName: string
  cityId: string
  districtName: string
  aoiPolygon: string
  predictNum: number
}

/**
 * 获取商圈
 */
export async function getBusinessDistrict(cityId: string): Promise<BusinessDistrictVO[]> {
  try {
    const result = await request.get<BusinessDistrictVO[]>(`/v2/starbucks/businessDistrict`, {
      params: {
        cityId,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

interface GridScoreVO {
  cityName: string
  cityId: string
  geohash: string
  scorePredict: number
}

/**
 * 获取选址热力
 */
export async function getStarbucksGridScore(cityId: string): Promise<GridScoreVO[]> {
  try {
    const result = await request.get<GridScoreVO[]>(`/v2/starbucks/gridScore`, {
      params: {
        cityId,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}
